import { deserialize, serialize } from "cerialize";
import EntityAware from "../EntityAware";

export default class TUKCashflowTrend implements EntityAware {
    @serialize
    @deserialize
    public label: string = "";

    @serialize
    @deserialize
    public income: number = 0;

    @serialize
    @deserialize
    public expense: number = 0;
}
